// What the signed-in user can open comes from the API: GET /api/auth/admin sends
// the role's sections as user.access. Full is fixed in the backend's
// utils/access.js and the other roles are edited on the Users page, so a role
// is given a section there and nowhere else. A key with a dot is an action
// inside a section, e.g. printer.disable. The sidebar, the login redirect and
// every route (PrivateRoute's section) check through canAccess.
// The backend checks the same list on its own; this only decides what is shown.
export const canAccess = (user, key) =>
  Boolean(user && Array.isArray(user.access) && user.access.includes(key));
